// wallpaper-v2.js — Casa Pop Panel Selector + Calculator + Cart
(function () {
  'use strict';

  var MIN_PANELS    = 4;   // ← Minimum panels required
  var MAX_PANELS    = 12;
  var selectedPanels = [];
  var LOCKED_VARIANT_ID = null;
  var totalMaxPanels = 12;

  // ── Helpers ──────────────────────────────────────────────
  function fmt2(n)  { return parseFloat(n.toFixed(2)); }
  function fmtINR(n){ return Math.round(n).toLocaleString('en-IN'); }
  function mToFt(m) { return fmt2(m * 3.28084); }

  // ── Config ───────────────────────────────────────────────
  function getConfig() {
    var el = document.getElementById('wv2-page');
    var metaPrice = el ? parseFloat(el.dataset.price) : 0;
    return {
      price: metaPrice > 0 ? metaPrice : 0,
      panel: parseFloat(el ? el.dataset.panel : 1.04) || 1.04
    };
  }

  // ── Kill Apippa ───────────────────────────────────────────
  function killApippa() {
    window.CustomPriceCalculator = undefined;
    window.apippa = undefined;
    window.cpp    = undefined;

    if (!window._wpXHRPatched) {
      window._wpXHRPatched = true;
      var _origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, url) {
        if (typeof url === 'string' && /custompricecalculator/i.test(url))
          arguments[1] = 'about:blank';
        return _origOpen.apply(this, arguments);
      };
    }

    if (!window._wpFetchPatched) {
      window._wpFetchPatched = true;
      var _orig = window.fetch;
      window.fetch = function (url, opts) {
        if (typeof url === 'string' && /custompricecalculator/i.test(url))
          return Promise.resolve(new Response('{}', { status: 200 }));
        return _orig.apply(this, arguments);
      };
    }
  }

  // ── Update Add to Cart Button State ──────────────────────
  function updateCartBtn() {
    var count = selectedPanels.length;
    var btn   = document.querySelector('#wv2-form [name="add"]');
    var warn  = document.getElementById('wv2-panel-warning');

    if (!btn) return;

    if (count === 0) {
      // No panels selected — neutral state
      btn.disabled = true;
      btn.classList.remove('wv2-btn--ready', 'wv2-btn--warn');
      if (warn) { warn.textContent = ''; warn.classList.remove('visible'); }

    } else if (count < MIN_PANELS) {
      // Some panels but below minimum — show warning
      btn.disabled = true;
      btn.classList.add('wv2-btn--warn');
      btn.classList.remove('wv2-btn--ready');
      var remaining = MIN_PANELS - count;
      if (warn) {
        warn.textContent = 'Please select at least ' + MIN_PANELS + ' panels. '
          + remaining + ' more panel' + (remaining > 1 ? 's' : '') + ' needed.';
        warn.classList.add('visible');
      }

    } else {
      // Minimum met — enable button
      btn.disabled = false;
      btn.classList.add('wv2-btn--ready');
      btn.classList.remove('wv2-btn--warn');
      if (warn) { warn.textContent = ''; warn.classList.remove('visible'); }
    }
  }

  // ── Build Panels ─────────────────────────────────────────
  function buildPanels() {
    var row       = document.getElementById('wv2-panels-row');
    var overlayEl = document.getElementById('wv2-overlay-lines');
    if (!row) return;

    row.innerHTML = '';
    if (overlayEl) overlayEl.innerHTML = '';
    selectedPanels = [];
    totalMaxPanels = MAX_PANELS;

    // Min panels hint
    var hint = document.getElementById('wv2-panel-hint');
    if (hint) hint.textContent = 'Minimum ' + MIN_PANELS + ' panels required.';

    for (var i = 1; i <= totalMaxPanels; i++) {
      (function (idx) {
        var item = document.createElement('label');
        item.className = 'wv2-panel-item';
        item.id        = 'wv2-panel-item-' + idx;

        var cb   = document.createElement('input');
        cb.type  = 'checkbox';
        cb.value = idx;
        cb.id    = 'wv2-cb-' + idx;
        cb.addEventListener('change', function () {
          onPanelToggle(idx, cb.checked);
        });

        var span = document.createElement('span');
        span.textContent = 'P-' + idx;

        item.appendChild(cb);
        item.appendChild(span);
        row.appendChild(item);

        // Overlay highlight + divider line
        if (overlayEl) {
          var pctLeft  = ((idx - 1) / totalMaxPanels) * 100;
          var pctWidth = (1 / totalMaxPanels) * 100;

          var hl       = document.createElement('div');
          hl.className = 'wv2-panel-hl';
          hl.id        = 'wv2-hl-' + idx;
          hl.style.left  = pctLeft  + '%';
          hl.style.width = pctWidth + '%';
          overlayEl.appendChild(hl);

          if (idx > 1) {
            var line       = document.createElement('div');
            line.className = 'wv2-panel-line';
            line.style.left = pctLeft + '%';
            overlayEl.appendChild(line);
          }
        }
      })(i);
    }

    updateCalc();
    updateCartBtn();
  }

  // ── Panel Toggle ─────────────────────────────────────────
  function onPanelToggle(idx, checked) {
    if (checked) {
      if (selectedPanels.indexOf(idx) === -1) selectedPanels.push(idx);
    } else {
      selectedPanels = selectedPanels.filter(function (p) { return p !== idx; });
    }

    var item = document.getElementById('wv2-panel-item-' + idx);
    if (item) item.classList.toggle('selected', checked);

    var hl = document.getElementById('wv2-hl-' + idx);
    if (hl) hl.classList.toggle('selected', checked);

    updateCalc();
    updateCartBtn(); // ← Update button state on every panel change
  }

  // ── Calculator ───────────────────────────────────────────
  function updateCalc() {
    var cfg     = getConfig();
    var hM      = parseFloat((document.getElementById('wv2-height') || {}).value) || 3.05;
    var panels  = selectedPanels.length;
    var billW   = fmt2(panels * cfg.panel);
    var billWFt = mToFt(billW);
    var areaM   = fmt2(billW * hM);
    var areaFt  = fmt2(areaM * 10.7639);
    var cost    = fmtINR(areaFt * cfg.price);

    setText('wv2-out-panels',   panels);
    setText('wv2-out-width-m',  billW);
    setText('wv2-out-width-ft', billWFt);
    setText('wv2-out-area-m',   areaM);
    setText('wv2-out-area-ft',  areaFt);
    setText('wv2-out-cost',     panels > 0 ? cost : 0);
  }

  function setText(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  // ── Height change ─────────────────────────────────────────
  function bindHeight() {
    var sel = document.getElementById('wv2-height');
    if (sel) sel.addEventListener('change', updateCalc);
  }

  // ── Gallery hero ─────────────────────────────────────────
  window.wv2SetHero = function (img) {
    var hero = document.getElementById('wv2-hero');
    if (hero && img.dataset.full) hero.src = img.dataset.full;
  };

  // ── Quantity ──────────────────────────────────────────────
  window.wv2Qty = function (delta) {
    var inp = document.getElementById('wv2-qty-val');
    if (!inp) return;
    inp.value = Math.max(1, (parseInt(inp.value) || 1) + delta);
  };

  // ── Tabs ─────────────────────────────────────────────────
  window.wv2Tab = function (btn, id) {
    document.querySelectorAll('.wv2-tab-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    document.querySelectorAll('.wv2-tab-content').forEach(function (c) {
      c.classList.remove('active');
    });
    btn.classList.add('active');
    var el = document.getElementById('tab-' + id);
    if (el) el.classList.add('active');
  };

  // ── Read More ─────────────────────────────────────────────
  window.wv2ReadMore = function () {
    var inner = document.getElementById('wv2-desc-inner');
    var btn   = document.getElementById('wv2-read-more');
    if (!inner) return;
    inner.classList.toggle('expanded');
    if (btn) btn.textContent = inner.classList.contains('expanded') ? 'Read Less' : 'Read More';
  };

  // ── Auto first tab ────────────────────────────────────────
  function initTabs() {
    var firstBtn     = document.querySelector('.wv2-tab-btn');
    var firstContent = document.querySelector('.wv2-tab-content');
    if (firstBtn)     firstBtn.classList.add('active');
    if (firstContent) firstContent.classList.add('active');
  }

  // ── Add to Cart — Pipeline Native ────────────────────────
  function addToCart(variantId, qty, btn) {
    var original = btn ? btn.textContent : 'ADD TO CART';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    // Read calculated values
    var heightEl   = document.getElementById('wv2-height');
    var heightText = heightEl ? heightEl.options[heightEl.selectedIndex].text : '';
    var areaM      = getText('wv2-out-area-m');
    var areaFt     = getText('wv2-out-area-ft');
    var totalCost  = getText('wv2-out-cost');
    var panels     = getText('wv2-out-panels');
    var widthM     = getText('wv2-out-width-m');
    var widthFt    = getText('wv2-out-width-ft');

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;

      var item = {};
      try { item = JSON.parse(xhr.responseText); } catch (e) {}

      if (xhr.status === 200 && item.id) {
        if (btn) {
          btn.textContent       = '✓ Added!';
          btn.style.background  = '#2d6a4f';
          btn.style.borderColor = '#2d6a4f';
          btn.disabled          = false;
        }

        var xhr2 = new XMLHttpRequest();
        xhr2.open('GET', '/cart.js');
        xhr2.setRequestHeader('Accept', 'application/json');
        xhr2.onreadystatechange = function () {
          if (xhr2.readyState !== 4 || xhr2.status !== 200) return;
          var cart = {};
          try { cart = JSON.parse(xhr2.responseText); } catch (e) {}

          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            bubbles: true, detail: { cart: cart }
          }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

          setTimeout(function () {
            var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
            if (cartDrawer) {
              cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            }
          }, 150);

          var count = cart.item_count || 0;
          document.querySelectorAll('[data-header-cart-count],.cart__count,[data-cart-count]')
            .forEach(function (el) {
              el.setAttribute('data-header-cart-count', count);
              el.innerHTML = '(' + count + ')';
            });
          document.querySelectorAll('[data-header-cart-full]').forEach(function (el) {
            el.setAttribute('data-header-cart-full', count > 0);
          });
        };
        xhr2.send();

        setTimeout(function () {
          if (btn) {
            btn.textContent       = original;
            btn.style.background  = '';
            btn.style.borderColor = '';
            updateCartBtn(); // re-check state
          }
        }, 2500);

      } else {
        var errMsg = item.description || item.message || 'Could not add to cart.';
        alert(errMsg);
        if (btn) { btn.textContent = original; btn.disabled = false; updateCartBtn(); }
      }
    };

    xhr.onerror = function () {
      if (btn) { btn.textContent = original; btn.disabled = false; updateCartBtn(); }
      alert('Network error. Please try again.');
    };

    xhr.send(JSON.stringify({
      id: Number(variantId),
      quantity: Number(qty),
      properties: {
        '_template':        'wallpaper-v2',
        'Wall Height':      heightText,
        'Total Panels':     panels,
        'Width':            widthM + ' m | ' + widthFt + ' ft',
        'Total Area':       areaM  + ' m² | ' + areaFt + ' ft²',
        'Total Cost (INR)': '₹' + totalCost
      }
    }));
  }

  function getText(id) {
    var el = document.getElementById(id);
    return el ? el.textContent.trim() : '0';
  }

  // ── Bind Form ─────────────────────────────────────────────
  var cartBound = false;
  function bindCart() {
    if (cartBound) return;
    var form = document.getElementById('wv2-form');
    if (!form) return;

    var idEl = form.querySelector('[name="id"]');
    if (idEl && idEl.value) LOCKED_VARIANT_ID = idEl.value;

    cartBound = true;

    var nf = form.cloneNode(true);
    form.parentNode.replaceChild(nf, form);

    // Init button as disabled (no panels selected yet)
    var btn = nf.querySelector('[name="add"]');
    if (btn) btn.disabled = true;

    nf.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      killApippa();

      // Double-check minimum panels
      if (selectedPanels.length < MIN_PANELS) {
        var warn = document.getElementById('wv2-panel-warning');
        if (warn) {
          warn.textContent = 'Please select at least ' + MIN_PANELS + ' panels to continue.';
          warn.classList.add('visible', 'shake');
          setTimeout(function() { warn.classList.remove('shake'); }, 500);
        }
        return;
      }

      var variantId = LOCKED_VARIANT_ID || nf.querySelector('[name="id"]').value;
      var submitBtn = nf.querySelector('[name="add"]');
      var costEl    = document.getElementById('wv2-out-cost');
      var calcCost  = costEl ? parseInt(costEl.textContent.replace(/[^0-9]/g, ''), 10) || 0 : 0;

      addToCart(variantId, calcCost, submitBtn);

    }, true);
  }

  // ── Init ─────────────────────────────────────────────────
  function init() {
    killApippa();
    buildPanels();
    bindHeight();
    bindCart();
    initTabs();
    updateCartBtn(); // Set initial disabled state

    var k = 0;
    var ki = setInterval(function () {
      killApippa();
      if (++k >= 10) clearInterval(ki);
    }, 500);
  }

  killApippa();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    killApippa();
    bindCart();
  });

  var tries = 0;
  var retry = setInterval(function () {
    tries++;
    killApippa();
    bindCart();
    if (cartBound || tries >= 10) clearInterval(retry);
  }, 300);

})();